import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import {
  addRequestedEventIdsAtom,
  useEventDialogSuppression,
} from 'src/hooks/api/useEventConfirmationDialogSuppressions.atoms';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import { AlertSuppressionSetting } from './AlertWithSuppressionDialog';

/**
 * Hook that returns the event mute timestamp for a specific alert type
 * @param key - The suppression key (e.g., 'suspiciousPriceSuppressionTimestamp')
 * @param viagogoEventId - Optional event ID for event-specific mutes
 * @returns The event mute timestamp if found, undefined otherwise
 */
export function useEventConfirmationDialogSuppressionTimestamp(
  key: keyof AlertSuppressionSetting,
  viagogoVirtualId?: string | null
): Date | undefined {
  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );
  const addRequestedEventIds = useSetAtom(addRequestedEventIdsAtom);
  useEffect(() => {
    if (viagogoVirtualId) {
      addRequestedEventIds({
        eventIds: [viagogoVirtualId],
        enabled: hasSellerEventAlertMutesFeature,
      });
    }
  }, [addRequestedEventIds, hasSellerEventAlertMutesFeature, viagogoVirtualId]);

  const suppression = useEventDialogSuppression(
    viagogoVirtualId ?? undefined,
    key
  );

  return useMemo(() => {
    if (!suppression) {
      return undefined;
    }

    return new Date(suppression.endDate);
  }, [suppression]);
}
